export default "__VITE_ASSET__zCx7Vjmi__"